import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useApi } from '../../hooks/useApi';
import { useNavigate, useParams } from 'react-router-dom';

const Password = () => {
  const [ password, setPassword ] = useState('');
  const [ passwordConfirmation, setPasswordConfirmation ] = useState('');
  const { post } = useApi();
  const navigate = useNavigate();
  const { token } = useParams();

  const validateInput = () => {
    const regPassword = /^[a-zA-Z0-9\-_@?!$%&]{8,100}$/;

    if (!password || !passwordConfirmation) {
      toast.error('パスワードとパスワード（確認）を入力してください。');
      return false;
    }
    if (!regPassword.test(password)) {
      toast.error('パスワードは半角英数記号8文字以上100文字以内で入力してください。使用可能記号: -_@?!$%&');
      return false;
    }
    if (password !== passwordConfirmation) {
      toast.error('パスワードとパスワード（確認）が一致しません。');
      return false;
    }
    return true;
  };

  const resetPassword = () => {
    if (!validateInput()) {
      return;
    }

    if (!token) {
      toast.error('無効なトークンです。');
      return;
    }

    post({
      endpoint: `/api/v1/password_resets/${ token }`,
      method: 'PUT',
      skipAuth: true,
      body: {
        password: password,
        password_confirmation: passwordConfirmation,
      },
      onSuccess: () => {
        toast.success('パスワードを更新しました。ログインしてください。');
        navigate('/login');
      },
      onError: (err) => {
        console.error(err);
        toast.error('パスワードの更新に失敗しました。時間をおいて再度お試しください。');
      },
    });
  };

  return (
    <section>
      <h2 className="curve_title">
        新しいパスワードを設定
      </h2>
      <div className="form">
        <dl className="graf_list">
          <dt>新しいパスワード</dt>
          <dd>
            <input
              type="password"
              value={ password }
              onChange={ e => setPassword(e.target.value) }
              placeholder="半角英数記号8文字以上 "
            />
          </dd>
          <dt>新しいパスワード（確認）</dt>
          <dd>
            <input
              type="password"
              value={ passwordConfirmation }
              onChange={ e => setPasswordConfirmation(e.target.value) }
              onKeyUp={ e => e.key === 'Enter' && resetPassword() }
              placeholder="パスワードを再入力してください"
            />
          </dd>
        </dl>
        <button
          className="w_bluebtn"
          type="submit"
          onClick={ resetPassword }
        >
          パスワードを更新
        </button>
      </div>
    </section>
  );
};

export default Password;
